export const checkIfUserComIsEnabled = userCom => {
  const { apiKey, appSubdomain, token } = userCom || {};
  return !!appSubdomain && !!token && !!apiKey;
};

export const checkIfUserComWithUserIdIsEnabled = userCom => {
  const { apiKey, appSubdomain, token, userId } = userCom || {};
  return !!appSubdomain && !!token && !!apiKey && !!userId;
};
